// extracted by mini-css-extract-plugin
export default {"business-edition-page":"BusinessEditionPage_business-edition-page__wvSsW","content":"BusinessEditionPage_content__gFB9U","text-center":"BusinessEditionPage_text-center__+-wO6"};